import { useEffect, useState, useRef } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, EffectFade, Navigation } from 'swiper'

import 'swiper/scss'
import 'swiper/scss/pagination'
import 'swiper/scss/navigation'
import 'swiper/scss/effect-fade'

import classNames from 'classnames'

import styles from './statistics_slider.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Stat from './stat'
import Image from './basic/image'

function StatisticsSlider(props) {
	const sliderRef = useRef()
	const fields = props.fields
	const [swiper, setSwiper] = useState(null);
	const [activeIndex, setActiveIndex] = useState(0);
	const [items, setItems] = useState(fields.items.map(obj => ({ ...obj, animate: false})))
	
	const sliderConfig = {
		modules: [Autoplay, EffectFade, Pagination, Navigation],
		spaceBetween: 0,
		slidesPerView: 1,
		noSwiping: true,
		autoplay: {
			delay: 4000,
		  },
		loop: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: false
		},
		navigation: {
			prevEl: `.${styles.previous}`,
			nextEl: `.${styles.next}`,
			clickable: true
		},
		// pagination: {
		// 	el: `.${styles.pagination}`,
		// 	clickable: true
		// },
		breakpoints: {
			0: {
				fadeEffect: {
					crossFade: true
				},
			},
			900: {
				fadeEffect: {
					crossFade: false
				},
			}
		},
		onSlideChange: (swiper) => {
			setActiveIndex(swiper.activeIndex)
			items[swiper.activeIndex].animate = true
			setItems(items)
		}
	}

	const handleItemClick = (e, index) => {
		e.preventDefault()

		swiper.slideTo(index)
		setActiveIndex(index)
	}

	useEffect(() => {
		const swiperObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.swiper.autoplay.start()
				} else {
					entry.target.swiper.autoplay.stop()
				}
			})
		}, {rootMargin: '-50% 0px -50% 0px'})

		swiperObserver.observe(sliderRef.current)

		return () => swiperObserver.disconnect()
	}, [sliderRef])

	
	return <BlockWrapper className={classNames(styles.statistics_slider)}>
			<ScrollAnimation styles={styles}>
				<div className={styles.statistics_slider_wrapper}>
					<div className={styles.nav_wrapper}>
						{fields.items.map((item, i) => {
							return <div className={classNames(styles.title, activeIndex == i ? styles.active : '')} key={i} onClick={(e) => handleItemClick(e, i)}>
								<h3 dangerouslySetInnerHTML={{ __html: item.title} } />
							</div>
						})}
					</div>
					<button aria-label='previous' className={styles.previous}></button>
					<div className={styles.slider_wrapper}>
						<Swiper ref={sliderRef} className={styles.statistics} {...sliderConfig} onSwiper={setSwiper}>
						{items && items.map((item, index) => {
							return <SwiperSlide className={styles.slide} key={index}>
								<h3 dangerouslySetInnerHTML={{ __html: item.title} } />
								<div className={styles.slide_wrapper}>
									{item.statistics && item.statistics.map((stat, stat_index) => {
										return <div className={styles.stat} key={stat_index}>
											<div className={styles.title}>
												{stat.title && <div className={styles.stat_wrapper}><Stat value={stat.title} animate={index == 0 ? true : item.animate} /></div>}
												{stat.image && <div className={styles.image_wrapper}><Image className={styles.image} {...stat.image} /></div>}
											</div>
											<div className={styles.description} dangerouslySetInnerHTML={{ __html: stat.description}} />
											<div className={styles.footnotes}>
												{stat.footnotes && stat.footnotes.map((footnote, i) => {
													return <div className={classNames(styles.footnote)} key={i} dangerouslySetInnerHTML={{ __html: `<sup>${footnote.reference_number}</sup>${footnote.note}`}} />
												})}
											</div>
										</div>
									})}
								</div>
							</SwiperSlide>
						})}
						</Swiper>
					</div>
					<button aria-label='next' className={styles.next}></button>
				</div>
			</ScrollAnimation>
	</BlockWrapper>
}

export default StatisticsSlider